var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoFreightintelAi = function SvgLogoFreightintelAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 418 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-freightintel-ai_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.346 16h-12.67V0h27.998c.748 0 1.37.607 1.37 1.34v27.98h-16.02V16.662a.687.687 0 0 0-.678-.677V16ZM16.697 32a.669.669 0 0 1-.678-.677V0L.396 15.421c-.24.24-.396.579-.396.96V46.66C0 47.407.607 48 1.37 48h30.104c.381 0 .72-.155.96-.395L48.058 32h-31.36Z",
    fill: "url(#logo-freightintel-ai_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.512 8.014h22.023v7.182h-14.38v5.7h14.38v7.055h-14.38V40h-7.63V8.014h-.013ZM88.996 8.014h13.773c7.713 0 12.022 4.953 12.022 10.991 0 4.078-1.978 7.535-5.17 9.425L115.582 40h-8.419l-4.521-9.594h-6.004V40H89.01V8.014h-.014Zm7.628 6.97v8.494h5.566c3.249 0 4.775-1.933 4.775-4.29 0-2.624-1.582-4.204-4.775-4.204h-5.566ZM117.645 8.014h22.107v7.097h-14.479v5.263h14.479v7.097h-14.479v5.432h14.479V40h-22.107V8.014ZM143.383 8.014h7.713V40h-7.713V8.014ZM154.133 24c0-9.284 6.837-16.423 16.499-16.423 6.145 0 10.652 2.54 13.689 6.434l-6.399 4.515c-1.54-2.37-3.998-3.725-7.233-3.725-4.958 0-8.9 3.936-8.9 9.199s3.73 9.157 9.041 9.157c3.687 0 6.272-1.834 7.374-4.995h-8.899v-7.097h17.191v3.64c0 8.452-6.272 15.732-15.525 15.732-10.439 0-16.796-7.576-16.796-16.423l-.042-.014ZM207.629 27.683h-10.482V40h-7.67V8.014h7.67v12.134h10.482V8.014h7.671V40h-7.671V27.683ZM227.11 15.069h-8.688V8.014h24.735v7.055h-8.603V40h-7.459V15.069h.015ZM246.406 8.014h7.713V40h-7.713V8.014ZM257.934 8.014h7.981l12.064 19.189V8.014h7.289V40h-7.416l-12.587-20.106V40h-7.331V8.014ZM297.063 15.069h-8.688V8.014h24.735v7.055h-8.603V40h-7.458V15.069h.014ZM316.219 8.014h22.108v7.097h-14.48v5.263h14.48v7.097h-14.48v5.432h14.48V40h-22.108V8.014ZM341.844 8.014h7.671v24.663h13.943V40H341.83V8.014h.014ZM389.322 8.014h7.374L408.534 40h-7.769l-1.667-4.769h-12.234L385.197 40h-7.713l11.838-31.986Zm-.084 20.543h7.543l-3.772-10.737-3.771 10.737ZM410.287 8.014H418V40h-7.713V8.014Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-freightintel-ai_svg__b",
    x1: 0.353,
    y1: 47.548,
    x2: 47.549,
    y2: 0.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-freightintel-ai_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h418v48H0z"
  })))));
};

export default SvgLogoFreightintelAi;